<template>
  <div>
    <el-card>
      <el-row class="title-biaoti">提现币商配置</el-row><el-row class="search">
        <el-select v-model="search.valid" placeholder="是否有效 " clearable="" filterable="">
          <el-option label="all" :value="-1"></el-option>
          <el-option label="无效" :value="0"></el-option>
          <el-option label="有效" :value="1"></el-option>
        </el-select>
        <el-select v-model="search.channel" placeholder="渠道筛选" clearable="" filterable="">
          <el-option label="ALL" value="ALL"></el-option>
          <el-option label="OTHER" value="OTHER"></el-option>
          <el-option label="Tikko" value="cde"></el-option>
        </el-select>
        <el-button type="primary" @click="query" :loading="login">
          查询
        </el-button>
        <el-button type="success" @click="operate(1)"> 新增</el-button>
        <el-button type="warning" @click="resetSearch"> 重置</el-button></el-row>
      <el-row>
        <el-table height="65vh" :data="dataList" style="width: 100%" v-loading="login" border>
          <el-table-column prop="name" label="名字" align="center" />
          <el-table-column prop="logo" label="logo" align="center" sortable>
            <template slot-scope="scope">
              <el-image style="width: 100px; height: auto" :src="scope.row.logo"
                :preview-src-list="[scope.row.logo]"></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="desc" label="描述" align="center" />
          <el-table-column prop="channel" label="渠道" align="center" />
          <el-table-column prop="weight" label="排序权重" align="center" />
          <el-table-column prop="valid" label="状态" align="center" sortable>
            <template slot-scope="scope">{{ scope.row.valid == 1 ? '有效' : '无效' }}
            </template>
          </el-table-column>
          <el-table-column prop="mtime" label="修改时间" align="center">
            <!-- 格式化 -->
            <template slot-scope="scope">{{ dateFormat(scope.row.mtime * 1000) }}</template>
          </el-table-column>
          <el-table-column prop="operator" label="操作人" align="center" />
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="operate(2, scope.row)">编辑</el-button>
            </template>
          </el-table-column></el-table>
      </el-row>
    </el-card>
    <el-dialog :title="type === 1 ? '新增提现币商配置' : '编辑提现币商配置'" :visible.sync="dialog" width="50%"
      :before-close="handleClose">
      <div class="item">
        <span>名字</span><el-input type="text" v-model="form.name"></el-input>
      </div>
      <div class="item">
        <span>logo</span><el-upload class="avatar-uploader" action="" :auto-upload="false" :show-file-list="false"
          :on-change="changfile" ref="upload">
          <el-image v-if="form.logo !== ''" style="width: 178px; height: auto" :src="form.logo"
            fit="scale-down"></el-image>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <div class="item">
        <span>描述：</span><el-input type="text" v-model="form.desc"></el-input>
      </div>
      <div class="item">
        <span>渠道：</span>
        <el-select v-model="form.channel" placeholder="选择渠道 " clearable="" filterable="">
          <el-option label="ALL" value="ALL"></el-option>
          <el-option label="OTHER" value="OTHER"></el-option>
          <el-option label="Tikko" value="cde"></el-option>
        </el-select>
      </div>
      <div class="item">
        <span>权重：</span><el-input type="number" v-model="form.weight"></el-input>
      </div>
      <div class="item">
        <span>是否有效：</span>
        <el-switch v-model="form.valid" active-text="有效" inactive-text="无效" :active-value="1"
          :inactive-value="0"></el-switch>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="operate(3)" type="primary" v-loading="dwnload" v-if="type === 1">
          新 增
        </el-button>
        <el-button @click="operate(4)" v-loading="dwnload" type="primary" v-else>
          更 新
        </el-button>
        <el-button @click="handleClose">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      login: false,
      dialog: false,
      dwnload: false,
      dataList: [],
      type: 1,
      search: {
        valid: -1,
        channel: 'ALL',
      },
      form: {
        id: '',
        name: '',
        logo: '',
        channel: '',
        desc: '',
        weight: '',
        valid: 1,
        operator: this.$store.getters.username,
      },
    }
  },
  async created() {
    this.query()
  },
  methods: {
    async query() {
      this.login = true
      const { data: res } = await this.$axios.get(
        this.$store.getters.path.withdraw_query +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token,
        {
          params: { ...this.search },
        }
      )
      this.login = false
      if (res.code != 0) return this.$message(res.msg)
      this.dataList = res.data

      this.login = false
    },
    resetSearch() {
      this.search = {
        valid: -1,
      }
      this.query()
    },
    async operate(type, obj) {
      this.type = type
      if (type == 1) {
        this.dialog = true
      } else if (type === 2) {
        this.dialog = true
        this.form = { ...obj }
      } else if (type === 3 || type === 4) {
        let url
        if (type === 3) {
          url =
            this.$store.getters.path.withdraw_add +
            '?username=' +
            this.$store.getters.username +
            '&token=' +
            this.$store.getters.token
          this.form.id = ''
        } else {
          url =
            this.$store.getters.path.withdraw_edit +
            '?username=' +
            this.$store.getters.username +
            '&token=' +
            this.$store.getters.token
        }
        this.form.operator = this.$store.getters.username

        const { data: res } = await this.$axios.post(url, this.form)
        if (res.code != 0) return this.$message.error(res.msg)
        this.dialog = false
        this.query()
        this.$message.success(res.msg)
      }
    },
    async changfile(file) {
      this.dwnload = true
      const formdata = new FormData()
      formdata.append('file', file.raw)
      formdata.append('cover', 0)
      formdata.append('dir', 'withdraw/partner/logo/')
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.hostmgr_upload +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token,
        formdata
      )
      this.dwnload = false
      if (res.code !== 0) {
        this.$refs.upload.clearFiles()
        return this.$message.error('文件上传失败请重新选择文件上传')
      }
      this.form.logo = res.data
    },
    handleClose() {
      this.form = {
        id: '',
        name: '',
        logo: '',
        desc: '',
        channel: '',
        weight: '',
        valid: 1,
        operator: this.$store.getters.username,
      }
      this.dialog = false
    },
    dateFormat(input, pattern = "") {
      // 在参数列表中 通过 pattern="" 来指定形参默认值，防止报错
      var dt = new Date(input)
      // 获取年月日
      var y = dt.getFullYear()
      var m = (dt.getMonth() + 1).toString().padStart(2, "0")
      var d = dt.getDate().toString().padStart(2, "0")
      // 如果 传递进来的字符串类型，转为小写之后，等于 yyyy-mm-dd，那么就返回 年-月-日
      // 否则，就返回  年-月-日 时：分：秒
      if (pattern.toLowerCase() === "yyyy-mm-dd") {
        return `${y}-${m}-${d}`
      } else {
        // 获取时分秒
        var hh = dt.getHours().toString().padStart(2, "0")
        var mm = dt.getMinutes().toString().padStart(2, "0")
        var ss = dt.getSeconds().toString().padStart(2, "0")
        return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
      }
    },
  },
}
</script>
<style scoped lang="scss">
.search {
  display: flex;

  >* {
    margin: 0 5px;
  }

  .el-input {
    width: 300px;
  }
}

.cell {
  display: flex;

  >* {
    margin: 2px;
  }
}

.item {
  display: flex;
  align-items: center;
  padding: 5px 0;

  span {
    white-space: nowrap;
    padding: 0 5px;
  }
}
</style>
